import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

// this state slice holds "original" reference spin json (that is initially
// available under "info" query parameter on Sirv) that enables detecting whether
// the user has unsaved changes
export const spinInfoSlice = createSlice({
  name: "spinInfo",
  initialState,
  reducers: {
    setSpinInfo(state, action) {
      return action.payload;
    },
    setSpinInfoHotspots(state, action) {
      const { hotspots } = action.payload;
      if (!state.settings) {
        state.settings = { hotspots };
      } else {
        state.settings.hotspots = hotspots;
      }
    },
  },
});
export const { setSpinInfo, setSpinInfoHotspots } = spinInfoSlice.actions;
export default spinInfoSlice.reducer;
